<script lang="ts" setup>
import AuthenticationCardLogo from "@/Components/AuthenticationCardLogo.vue"
</script>
<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center dark:bg-gray-900 pt-6 sm:pt-0 bg-gray-100">
        <div class="w-full sm:max-w-md">
            <div class="flex justify-center"><AuthenticationCardLogo /></div>

            <div
                v-if="$slots.title"
                class="space-y-1 text-center mt-8">
                <h2 class="text-3xl font-semibold dark:text-white"><slot name="title" /></h2>

                <p
                    class="font-medium dark:text-gray-500 text-gray-700"
                    v-if="$slots.description">
                    <slot name="description" />
                </p>
            </div>

            <slot name="header" />
        </div>

        <div
            class="w-full sm:max-w-md mt-6 px-6 py-4 dark:bg-gray-800 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <slot />
        </div>

        <div>
            <slot name="footer" />
        </div>
    </div>
</template>
